import React from 'react';
import {Button, message, Modal} from "antd";
import {attrParser} from "../../../../base/BaseComponent";
import {uuid} from "../../../../utils";
import ActivitiModal from "../../../editor/components/activitiAndBtn/ActivitiModal";
import {Scrollbars} from "react-custom-scrollbars";
import NormalModal from "./normalModal";
import {loadJsCssFile} from "../../../../utils/index";
import $ from "jquery";
import {systemBaseEvent} from "../../../../base/baseEvent";
import AddModal from "./addModal";

export const loadJsFileLoader = {
    getFullUrl: (fileName)=>{
        return `/cm-sites/js/business/${fileName}.js`
    },
    checkIsLoaded: (url)=>{
        return $(`script[src='${loadJsFileLoader.getFullUrl(url)}']`).length > 0;
    },
    load: (url) => {
        if(!loadJsFileLoader.checkIsLoaded(url)){//如果没有被加载过的话，那么就加载
            loadJsCssFile(loadJsFileLoader.getFullUrl(url), "js");
        }
    }
};


class DetailsModal extends NormalModal {
    version = 0;
    id = uuid();
    formData = {};

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            activityOption: {},//流程配置文件
            loadKeyByShow: uuid(),
            loadKeyByHide: uuid(),
            id: "",
            data: {}
        }
    }

    componentWillMount() {
        let that = this;
        this.createPostMessage((e)=>{
            let message = e['data']&&typeof e.data ==='string' ? JSON.parse(e['data'])['message'] : null;
            if (message == "请求刷新父页面") {
                that.show(this.state.id,this.otherData);
            }
        }, "normal")
    }

    componentWillUnmount() {
        this.destroyPostMessage("normal");
    }

    cleanData = () => {
        this.state.id = "";
        this.state.activityOption = {};
        this.formData = {};
        this.otherData = {};
    };
    otherData = {};

    show(id, otherData = {}) {
        if (!id) {
            return false;
        }
        this.cleanData();
        this.otherData = otherData;
        this.state.loadKeyByShow = uuid();
        this.state.id = id;
        this.detailsShow(id, (res) => {
            if (res) {
                this.state.data = res;
                this.state.visible = true;
                this.initActivitiConfig(res);
            }
        });
    };
    hide = () => {
        this.state.loadKeyByHide = uuid();
        this.setState({visible:false});
    };
    detailsShow = (id, call)=>{
        let url = "";
        let method = "";
        let contentType = "";
        let body = null;
        this.props.sysConfigData.port.forEach((item) => {
            if (item.type === "get") {
                url = item.url;
                method = item.method;
                contentType = item.contentType;
                body = item.ajaxBody;
            }
        });
        this.request({
            url: "" + url + id,
            method: method,
            contentType: contentType,
            body: body,
            callBack: (res) => {
                if(res){
                    this.formData = res;
                    this.version = res.version;
                    call&&call(res);
                }
            },
            errorCallBack: (e) => {
            },
        })
    }

    /**设置流程配置*/
    initActivitiConfig(data) {
        let id = data.id ? data.id : '';
        let that = this;
        let account = (window.currentUser && window.currentUser.account) ? window.currentUser.account : "";
        // 判断操作权限start
        let showBtnFlag = true;
        let pojoName = this.props.pojoName;
        let activitiConf = {type: this.props.activitiConfName};
        let againFlag = false;
        // 判断操作权限end
        this.state.activityOption = {
            ...this.state.activityOption,
            id: id,//流程id
            activitiConf,//流程conf
            pojoName: pojoName,//数据表name
            userAccount: account,//当前用户account
            showBtnFlag,//是否显示流程按钮
            againFlag,//重置流程的判断条件
            showAfterFuns: {},//流程按钮加载前置js
            getTextRequisite: false,//备注是否必填
            otherJs: {
                needRemarks :function(activiti, buttonConf, call){
                    activiti.getText(null,null,function(res){
                        activiti.actForm.values.otherData = {};
                        activiti.actForm.values.otherData = res;
                        call({code: 1});
                    },{notNull:true})
                },
                callActRevert: (activiti, buttonConf, call) => {
                    // window.loading.show(true);
                    activiti.terminate.call(activiti, (res) => {
                        if (res) {
                            activiti.options.statusNameTemp = "草稿";
                            activiti.endFunction(activiti, function (res) {
                                if (res.status) {
                                    activiti.successMsg("流程已撤回，状态变为草稿", function () {
                                        activiti.submitOK.call(activiti);
                                    });
                                }
                            })
                        }
                    });
                }
            },//流程按钮点击事件前置js
            saveFunction: that.save,//稿件保存方法
            saveStatusNameFunction: that.updateStatus,//稿件改流程状态方法
            onSubmitOK: function (activiti) {
                that.refresh(activiti)
            },//流程事件运行完毕的回调
            successCall: () => {
            },//流程加载完的回调
            readyCall: () => {
            },//流程初始化完的回调
            showRemarks: (remarks) => {
                // console.log("remarks, info, all:  ", remarks, info, all);
            },//备注回显
            onlyShowBtn: true,//是否只返回流程按钮
            title: '',//流程弹窗title
            visible: false,//流程弹窗是否展示
            mustNotShowPublishBtn: true, // 投稿编辑器中永远不显示发布按钮
            btnLoadOver: (btns) => {
                this.setState({btns})
            },
            showBtnIcon: true,
            btnType: "topicAndClue",
        };
        this.setState({});
    }

    render() {
        let data = {detailsData: this.formData};
        let sysConfigData = this.props.sysConfigData;
        this.convertBtn(sysConfigData.detailsBtns);
        let footer = this.buildFooterBtn(sysConfigData.detailsBtns);
        if(this.otherData?.showBtn === false) {
            footer = []
        }
        if(sysConfigData.activitiConfName && this.state.activityOption.pojoName) {
            footer.push(<ActivitiModal
                {
                    ...this.state.activityOption
                }
                key={"activitiModalDetail"+this.state.loadKeyByShow}
            />);
        }
        let id = `a-${this.id}-modal`;
        const addProps = {...this.props,pageType:sysConfigData.title}
        return (
            <Modal
                visible={this.state.visible}
                title={this.props.details}
                onOk={() => {
                    this.props.callBack && this.props.callBack()
                }}
                onCancel={() => {
                    this.hide()
                }}
                maskClosable={false}
                footer={footer.length === 0 ? [<Button type={"primary"} onClick={this.hide}>关闭</Button>] : footer}
                width={sysConfigData.detailsWidth || 800}
                key={this.state.loadKeyByHide}
            >
                <Scrollbars autoHide autoHeight autoHeightMax={document.body.clientHeight > 400 ? document.body.clientHeight - 300: document.body.clientHeight}>
                    <div id={id}>
                        {sysConfigData.detailsInputs.map((item, index) => {
                            return (
                                <div key={index} style={{display: "flex"}}>{
                                    item.map((componentItem, _index) => {
                                        let ItemComponent = null;
                                        try {
                                            ItemComponent = require(`../formDetails/${componentItem.component}.js`).default;
                                        } catch (e) {
                                            console.log(e.toString())
                                        }
                                        let props = componentItem.props;
                                        let details = "";
                                        if (props.details) {
                                            details = attrParser(props.details, data);
                                            if(props.details.indexOf("${") > -1){//说明有表达式
                                                if(details === props.details){//如果解析失败，那么就不展示
                                                    details = "";
                                                }
                                            }
                                        }
                                        if(details === "undefined") {
                                            details = "";
                                        }
                                        if(props.condition&&props.condition.length){
                                            return <ItemComponent key={index + "_" + _index} {...props} data={details} dataSource={this.state.data}/>;
                                        }else{
                                            return <ItemComponent key={index + "_" + _index} {...props} data={details} />;
                                        }

                                    })}
                                </div>
                            )

                        })}
                        <AddModal {...addProps} ref={ref => this.addModal = ref } />
                    </div>
                </Scrollbars>
                <style>{`
                    #${id} .ant-form-item-label{
                        width: ${sysConfigData.labelWidth || 100}px;
                        vertical-align: top;
                    }
                    #${id} .ant-form-item{
                        margin-bottom: 0 !important
                    }
                    #${id} .ant-form-item-label > label{
                        color: #aaa6a6  !important;
                    }
                    #${id} .ant-form-item-control .ant-form-item-children{
                        color: #252424 !important;
                    }
                `}</style>
            </Modal>
        );
    }

    // 写稿
    editManuscript = ({btnInfo,editParams={}}) => {
        // console.log("-----------------------", btnInfo, this.otherData);
        let activitiConfName = btnInfo.storyActivitiConfName;//"activitiTreeRoot-appointment";
        let businessName = btnInfo.businessName;//"yg"
        let storyIdFieldName = btnInfo.storyIdFieldName || "storyId";

        window.openEditById({
            params: {
                activitiConfName,
                businessId: this.state.id,
                businessName,
                version: this.otherData.version,
                status: btnInfo.status,
                // appointmentId: this.otherData.appointmentId,
                // // 新增字段
                // requireContent: this?.otherData?.appointmentObj?.requireContent || "",
                // appointmentCreater: this?.otherData?.appointmentObj?.publisher?.id || "",
                ...editParams,
            },
            configName: "reservationEditor",
            id: this.formData[storyIdFieldName] || 0
        });
        this.refresh();
    };
    // 修改状态按钮
    modifyState = ({btnInfo, currentBtn}) => {
        let params = {status: currentBtn.status, version: this.version};
        this.request({
            url: `/cm-sites-business/bd/busAppointment/update/${this.state.id}`,
            method: "post",
            contentType: "json",
            body: params,
            callBack: (res) => {
                if (res) {
                    message.success("修改成功");
                    this.refresh()
                }
            },
            errorCallBack: (e) => {
            },
        });
    };
    // 保存
    save = (activiti, call, status) => {

        //详情页没有数据修改  无需实现
        call && call(this.formData);
    };
    //修改状态
    onlyUpdateStatus = ({id, status, msg, successMsg, errorMsg, btnInfo,version}) => {
            if(btnInfo.isTips){
                Modal.confirm({
                    title: `你确定${btnInfo.name}这条${btnInfo.title}吗？`,
                    okText: '确认',
                    cancelText: '取消',
                    onOk: ()=> {
                        this.isUpdate({id, status, msg, successMsg, errorMsg, btnInfo,version})
                    }
                });
            }else{
                this.isUpdate({id, status, msg, successMsg, errorMsg, btnInfo,version})
            }

    };
    isUpdate = ({id, status, msg, successMsg, errorMsg, btnInfo,version}) =>{
        this.update({
            id, status, btnInfo,version, call: (res) => {
                if (msg) {
                    if (res.status) {
                        message.success(successMsg ? successMsg : (msg + "成功！"));
                    } else {
                        message.error(errorMsg ? errorMsg : (msg + "失败！"));
                    }
                }
                if(btnInfo.autoClose !== false){
                    this.refresh();
                }else{
                    this.show(this.state.id, this.otherData);
                    this.props.callBack && this.props.callBack();
                }
            }
        });
    };
    //修改状态
    updateStatus = (status, activiti, call) => {
        let {id} = this.state;
        if (!id) {
            return
        }
        this.update({id, status, activiti, call});
    };
    update = ({id, status, activiti, call, btnInfo = {},version, refuseDate, otherParams = {}}) => {
        // 取接口参数
        let url = "";
        let method = "";
        let contentType = "";
        let portType = btnInfo.portType ? btnInfo.portType : "update";
        this.props.sysConfigData.port.forEach((item) => {
            if (item.type === portType) {
                url = item.url;
                method = item.method;
                contentType = item.contentType;
            }
        });
        if (!url || !method || !contentType) {
            window.loading.hide();
            call && call(false);
            return false;
        }
        let params = {
            id,
            status, ...otherParams,
            version: version || this.version,
        };
        if (url.indexOf("busAppointmentReceiver") > -1) {
            params = {
                ...params,
                requireContent: this?.otherData?.appointmentObj?.requireContent || "",
                appointmentCreater: this?.otherData?.appointmentObj?.publisher?.id || "",
            }
        }
        if (refuseDate) {
            params = {
                ...params,
                refuseDate
            }
        }
        let that = this;
        this.request({
            url: url + id,
            method: method,
            contentType: contentType,
            body: params,
            callBack: function (res) {

                ////如果存在，动态的加载一个js
                if (res) {
                    if(btnInfo.dynamicScript){
                        loadJsFileLoader.load(btnInfo.dynamicScript);
                        systemBaseEvent.asyncPlaybackExec(btnInfo.dynamicScript, {
                            data: that.formData,
                            request: that.request,
                            configData: that.props.sysConfigData
                        });
                    }
                    call && call({status: true, msg: "流程推进后状态修改成功。"});
                } else {
                    call && call({status: false, msg: "流程推进后状态修改失败。"});
                }
            },
            errorCallBack: function (e) {
                console.log(e.toString());
                call && call({status: false, msg: "流程推进后状态修改失败。"});
            }
        })
    };

    // 用于编辑按钮的编辑功能
    edit = ({record}) => {
        this.addModal.show(record?.id);
        this.setState({visible:false});
    }
}

export default DetailsModal;
